import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { trackEvent } from "../analytics/plausible";

export function NavigationTracker() {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const to = location.pathname + location.search + location.hash;

    const from = (previousPathRef.current ?? document.referrer) || "direct";

    // Skip first render if you don't want an initial nav event
    if (previousPathRef.current !== null) {
      trackEvent("pageview", { u: to });
      trackEvent("navigate_to", {
        from,
        to,
      });
    }

    previousPathRef.current = to;
  }, [location.pathname, location.search, location.hash]);

  return null;
}
